import { render, staticRenderFns } from "./EventCategorySetup.vue?vue&type=template&id=cccd0678&scoped=true"
import script from "./EventCategorySetup.vue?vue&type=script&lang=ts"
export * from "./EventCategorySetup.vue?vue&type=script&lang=ts"
import style0 from "./EventCategorySetup.vue?vue&type=style&index=0&id=cccd0678&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cccd0678",
  null
  
)

export default component.exports